<script setup lang="ts">
import Skeleton from '~/components/common/Skeleton.vue';

type Props = {
  hasTitle?: boolean;
};

withDefaults(defineProps<Props>(), {
  hasTitle: true,
});
</script>

<template>
  <div class="money-amount">
    <div v-if="hasTitle" class="money-amount__title">
      <Skeleton variant="text" theme="light" />
    </div>

    <Skeleton variant="text" theme="light" class="money-amount-value" />
  </div>
</template>

<style lang="scss" scoped>
.money-amount {
  display: flex;
  flex-direction: column;

  width: 100%;
}

.money-amount__title + .money-amount-value {
  margin-top: 0.625rem;
}

.money-amount-value {
  font-size: var(--font-size-lg);
}
</style>
